export default __webpack_public_path__ + "static/media/29.8d9339b0.png";